import React from 'react';
import { NavLink } from 'react-router';
import './Contact.css';
import{ 
FaInstagram, 
FaTwitter, 
FaFacebookF, 
FaWhatsapp,
} from 'react-icons/fa';

const ContactUs = () => {


  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
  };

  return (
    <>
    <title>Faidika Real Estate Limited - Contact Us</title>
    <meta name="description" content="Contact Faidika Real Estate Limited for inquiries, site visits, and more. Reach us via phone or email." />
    <meta name="keywords" content="Faidika, Real Estate, Contact, Site Visit, Inquiries" />

    <h2 className="section-title">Get in touch with us:</h2>

    <section className="contact-container">      
      
      <div className="contact-content">
         <div className="contact-info">
              <h3>Our Official Contact Details</h3>
                 <p><b>Along Thika Superhighway – Spur Mall 2nd Floor<br />
                     Kimbo, Kiambu County</b></p>
                 <p><b>Phone:</b> +254 717 520 520</p>
                 <p><b>Email:</b> <span className="mail">info@faidika.com</span></p>
            
                <div className="social-links">
                   <NavLink to =""><FaInstagram className="social-icon" aria-label="Instagram" /></NavLink>
                   <NavLink to =""><FaTwitter className="social-icon" aria-label="Twitter" /></NavLink>
                   <NavLink to =""><FaFacebookF className="social-icon" aria-label="Facebook" /></NavLink>
                   <NavLink to =""><FaWhatsapp className="social-icon" aria-label="WhatsApp" /></NavLink>
                </div>
          </div>

      <div className="map-column">
          <div className="map-container">
          <iframe 
              src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.0335860489417!2d36.96765887496537!3d-1.1363954988527183!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f3fc955678a67%3A0xb42cac64d8e16dea!2sSpur%20Mall!5e0!3m2!1sen!2ske!4v1746003003812!5m2!1sen!2ske`}
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              title="Faidika Lands Limited"
            ></iframe>
          </div>
        </div>


        <div className="contact-column">
            <h3>Schedule a Site Visit</h3>

            <p>
                Interested in any of our projects today, feel free to schedule a site visit with us any time. 
                It is free of charge, so don’t be limited.
            </p>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name:</label>
              <input type="text" id="name" name="name" required />
            </div> 
            
            <div className="form-group">
              <label htmlFor="phone">Mobile No:</label>
              <input type="tel" id="phone" name="phone" required />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Message:</label>
              <textarea id="message" name="message" rows="5" required></textarea>
            </div>
            
            <button type="submit" className="submit-btn">Send</button>
          </form>          
        </div>

        
      </div>
    </section>
    </>
  );
};

export default ContactUs;